import type { BECompletionV4 } from "@kivra/sdk/types/core/completion";
import type { RootState } from "../rootReducer";
import type { TermsState } from "./authSlice";
import type { TunnistusState } from ".";
import type { FetchState, OTPState } from "../../utils/use-completions";

export const getUsername = (state: RootState): string => state.auth.username;
export const getTunnistusEmail = (state: RootState): string =>
  state.auth.tunnistusData.emailAddress;
export const getIsUserLoading = (state: RootState): boolean =>
  state.auth.isLoading;
export const getPhoneNumber = (state: RootState): string =>
  state.auth.phoneNumber;

const negateBoolean =
  (fn: (state: RootState) => boolean): (state: RootState) => boolean =>
  (state: RootState) => !fn(state);

const getIsUsernameValid = (state: RootState): boolean =>
  RegExp(".+@.+").test(getUsername(state));

export const getIsUsernameInvalid = negateBoolean(getIsUsernameValid);

export const getResourceOwner = (state: RootState): string =>
  state.auth.tunnistusData.resourceOwner;

export const getTunnistusData = (state: RootState): TunnistusState =>
  state.auth.tunnistusData;

// Maybe also add a function for getting the resource key directly?
export const getUserIdFromResourceOwner = (resource_owner: string): string =>
  resource_owner.split("_")[1] || "";

export const getIsSignupDisabled = (state: RootState): boolean =>
  getIsUserLoading(state) || getIsUsernameInvalid(state);

export const getTerms = (state: RootState): TermsState => state.auth.terms;
export const getTermsAccepted = (state: RootState): boolean =>
  state.auth.terms.termsAccepted;

export const getCompletions = (state: RootState): BECompletionV4[] =>
  state.auth.completions;

export const getCompletionFetchState = (state: RootState): FetchState =>
  state.auth.completionFetchState;

export const getCompletionOTPState = (state: RootState): OTPState =>
  state.auth.completionOTPState;

export const getNewPassword = (state: RootState): string =>
  state.auth.passwordResetData.newPassword;

export const getVerifyPassword = (state: RootState): string =>
  state.auth.passwordResetData.verifyNewPassword;

export const getAccessToken = (state: RootState): string =>
  state.auth.tunnistusData.accessToken;

export const getTokenType = (state: RootState): string =>
  state.auth.tunnistusData.tokenType;

const getIsPasswordValid = (state: RootState): boolean =>
  RegExp("^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d).{10,}$").test(
    getNewPassword(state),
  );

const getIsVerifyPasswordValid = (state: RootState): boolean =>
  getNewPassword(state) === getVerifyPassword(state);

export const getIsPasswordInvalid = negateBoolean(getIsPasswordValid);
export const getIsVerifyPasswordInvalid = negateBoolean(
  getIsVerifyPasswordValid,
);
